<template>
  <n-switch
    :value="modelValue"
    :disabled="disabled"
    @update:value="(value) => emit('update:modelValue', value)"
  ></n-switch>
</template>

<script setup lang="ts">
interface SelectOptions {
  label: string
  value: any
  disabled?: boolean
}
// 定义Emits接口
interface SelectFieldEmits {
  (
    e: 'update:modelValue',
    value: string | number | boolean | (string | number | boolean)[] | undefined
  ): void
  (
    e: 'change',
    value: string | number | boolean | (string | number | boolean)[] | undefined
  ): void
}
const props = defineProps<{
  modelValue: string | number | undefined
  disabled?: boolean
  [key: string]: any
}>()

const emit = defineEmits<SelectFieldEmits>()
</script>
